<template>
  <div class="floating-label mb-3">
    <input
      v-if="type != 'textarea' && type != 'flag' && type != 'plain' && type != 'link'"
      :value="value"
      @input="update($event)"
      :type="type"
      :placeholder="placeholder"
      :required="required"
      :readonly="readonly"
      :disabled="disabled"
      :class="['form-control ', controlSize, eclass, stateVal]"
      :autocomplete="autocomplete || null"
      :aria-describedby="ariaDescribedby"
      :step="step"
      ref="input"
    />
    <textarea
      v-if="type == 'textarea'"
      wrap="soft"
      :class="['form-control ', controlSize, eclass, stateVal]"
      :value="value"
      @input="update($event)"
      :required="required"
      :readonly="readonly"
      :disabled="disabled"
      :autocomplete="autocomplete || null"
    ></textarea>
    <div class="form-control" v-if="type == 'flag'">
      <i class="flag-icon" :class="'flag-icon-' + (value ? value.toLowerCase(): '')" />
    </div>
    <div class="form-control" v-if="type == 'plain'">
      <strong>{{value}}</strong>
    </div>
    <div class="form-control" v-if="type == 'link'">
      <router-link :to="to">{{value}}</router-link>
    </div>
    <label v-if="label" :class="{stay: isNotEmpty(value), animate: animate}">{{$t(label)}}</label>
    <slot name="feedback"></slot>
    <small v-if="description" class="form-text text-muted pl-3">{{$t(description)}}</small>
  </div>
</template>

<script>
export default {
  name: "floatingLabelValue",
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    to: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    step: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    autocomplete: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    state: {
      type: Boolean,
      default: null
    },
    ariaDescribedby: {
      type: String,
      default: ""
    },
    eclass: {
      type: String,
      default: ""
    },
    debounce: {
      type: Boolean,
      default: false
    },
    delay: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      myval: "",
      animate: false,
      timeoutID: 0
    };
  },
  created() {
    const self = this;
    window.setTimeout(() => {
      self.animate = true;
    }, 1000);
  },
  computed: {
    controlSize() {
      return this.size ? `form-control-${this.size}` : "";
    },
    stateVal() {
      return this.state === true
        ? "is-valid"
        : this.state === false
        ? "is-invalid"
        : "";
    }
  },
  methods: {
    isNotEmpty(val) {
      if (typeof val == "number") {
        return val != null;
      }
      return val != "";
    },
    update(e) {
      if (this.debounce) {
        const self = this;
        window.clearTimeout(this.timeoutID);
        this.timeoutID = window.setTimeout(() => {
          self.$emit("input", self.$refs.input.value);
        }, this.delay);
      } else {
        this.$emit("input", e.target.value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.floating-label {
  position: relative;
}

label.animate {
  transition: 0.15s ease-out all;
}

.form-control + label {
  display: block;
  cursor: text;
  color: #aaa;
  position: absolute;
  top: 0.65rem;
  left: 1rem;
  pointer-events: none;
}
.form-control.form-control-sm + label {
  top: 0.5rem;
}
.form-control:focus + label,
label.stay {
  top: -0.75em;
  left: 1em;
  font-size: 0.8em;
  color: #5fccff;
  background-color: #fff;
  padding: 0 0.3rem;
}
label.stay {
  color: #afb4d2;
}
.form-control.form-control-sm + label.stay {
  top: -0.75em;
}
.form-control.form-control-sm.is-valid + label.stay {
  color: #1dc9b7;
}
.form-control.form-control-sm.is-invalid + label.stay {
  color: #dc3545;
}
</style>
